// extracted by mini-css-extract-plugin
module.exports = {"heading":"P22NIHAuneINyZetWDAcJ","downloadBnt":"_1SwXy_4mR_Xg8DBJ7fErWG"};